// extracted by mini-css-extract-plugin
module.exports = {"hitPoints":"CharacterBuilderClassHitPoints_hitPoints_3WPOD"};